import { useQuery } from "@tanstack/react-query";
import { summaryApi } from "../lib/summaryApi";
import { SUMMARY_STALE_TIME } from "../lib/queryConfig";

export const SUMMARY_KEYS = {
  employee: ["summary", "employee"] as const,
  admin: ["summary", "admin"] as const,
  bizAdmin: (businessId: string) => ["summary", "biz", businessId] as const,
};

export function useEmployeeSummary() {
  return useQuery({
    queryKey: SUMMARY_KEYS.employee,
    queryFn: summaryApi.employee,
    staleTime: SUMMARY_STALE_TIME,
  });
}

export function useAdminSummary(enabled = true) {
  return useQuery({
    queryKey: SUMMARY_KEYS.admin,
    queryFn: summaryApi.admin,
    staleTime: SUMMARY_STALE_TIME,
    enabled,
  });
}

export function useBusinessSummary(businessId: string | null) {
  return useQuery({
    queryKey: SUMMARY_KEYS.bizAdmin(businessId ?? ""),
    queryFn: () => summaryApi.bizAdmin(businessId!),
    enabled: !!businessId,
    staleTime: SUMMARY_STALE_TIME,
  });
}
